import React from 'react';
import { Row, Col, TreeSelect, Typography } from 'antd';
import { useTheme } from '../../../contexts/ThemeContext';

const { Text } = Typography;
const { TreeNode } = TreeSelect;

const TotalizadorCard = ({
  title,
  subtitle,
  color,
  selected,
  liquidValue,
  onChangeSelected,
  onChangeLiquidValue,
  options = []
}) => {
  const { theme } = useTheme();

  return (
    <div style={{
      backgroundColor: color || theme.background,
      borderRadius: 8,
      padding: 16,
      marginBottom: 16,
      border: `1px solid ${theme.border}`,
      minHeight: 120
    }}>
      <div style={{ marginBottom: 12 }}>
        <Text strong style={{ fontSize: 14, display: 'block', marginBottom: 4 }}>
          {title}
        </Text>
        <Text style={{ fontSize: 12, color: theme.textSecondary }}>
          {subtitle}
        </Text>
      </div>

      <Row gutter={12}>
        <Col span={24}>
          <TreeSelect
            style={{ width: '100%' }}
            value={selected}
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            treeDefaultExpandAll
            placeholder="Selecione totalizador, conta ou subconta"
            showSearch
            treeNodeFilterProp="title"
            filterTreeNode={(input, node) => {
              const t = (node?.title || '').toString().toLowerCase();
              return t.includes((input || '').toLowerCase());
            }}
            onChange={onChangeSelected}
            allowClear
            multiple
            treeCheckable
            showCheckedStrategy={TreeSelect.SHOW_PARENT}
            treeData={(options && options.length > 0 && options[0].children)
              ? options
              : options.map(opt => ({
                  title: opt.label,
                  value: opt.value,
                  key: opt.value
                }))}
          />
        </Col>
        
      </Row>
    </div>
  );
};

export default TotalizadorCard;


